import { render, staticRenderFns } from "./face-element.vue?vue&type=template&id=f1b47dec&scoped=true"
import script from "./face-element.vue?vue&type=script&lang=js"
export * from "./face-element.vue?vue&type=script&lang=js"
import style0 from "./face-element.vue?vue&type=style&index=0&id=f1b47dec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b47dec",
  null
  
)

export default component.exports